import { useMutation, useQueryClient } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';

import { LABEL_QUERY_KEYS, TCreateLabel, TLabel } from './query-keys';

const postLabel = (data: TCreateLabel): Promise<TLabel> => {
  return mediaManagerClient.post('/api/v1/labels', data);
};

export const usePostLabel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [LABEL_QUERY_KEYS.LABELS],
      });
    },
    mutationFn: postLabel,
  });
};
